import React from 'react'
import styled from 'styled-components'
import { MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import { OutlinedButton, ButtonSize, ButtonPaint, Link } from 'streamr-ui'
import RoundedBox from '../RoundedBox'
import tokenomics from './assets/tokenomics.png'
import tokenomics2x from './assets/tokenomics@2x.png'
import Topic from '~shared/Topic'
import urls from '~utils/urls'

const IconContainer = styled.div`
    position: relative;
    width: 200px;
    height: 200px;

    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-65%, -50%);
        width: 100%;
    }

    @media ${MqTablet} {
        width: 262px;
        height: 262px;

        img {
            transform: translate(-50%, -50%);
        }
    }

    @media ${MqDesktop} {
        width: 360px;
        height: 360px;
    }
`

const Tokenomics = () => (
    <RoundedBox $appear>
        <RoundedBox.Inner>
            <RoundedBox.Content>
                <Topic.Title>Tokenomics</Topic.Title>
                <Topic.Paragraph>
                    The Network can operate as a free and open data network, but it also provides
                    incentives for users to run sponsored nodes to provide a higher quality of
                    service, and allows token holders to earn by staking on Operators that share
                    revenue.
                </Topic.Paragraph>
                <OutlinedButton
                    tag={Link}
                    size={ButtonSize.Moose}
                    paint={ButtonPaint.PrimaryOutlined}
                    href={urls.token}
                >
                    Explore tokenomics
                </OutlinedButton>
            </RoundedBox.Content>
            <RoundedBox.Icon>
                <IconContainer>
                    <img src={tokenomics} srcSet={tokenomics2x} alt="" />
                </IconContainer>
            </RoundedBox.Icon>
        </RoundedBox.Inner>
    </RoundedBox>
)

export default Tokenomics
